<template>
    <div class="kleptos-icon-view">

        <!-- ICON GRID :constrain="totalIcons" -->
        <!-- <icon-grid

            @coords="coords = $event">
        </icon-grid> -->

        <!-- ICONS -->
        <!-- <icon
            v-for="(item, index) in directory"
            :key="index"
            :index="index"
            :node="item"
            :coords="coords"
            @dblclick.native="openWindow('appFileSystem')"
            @drag-active="active = $event">
        </icon> -->

        <!-- ICONS - OLD -->
        <!-- <icon
            v-for="(item, index) in directory"
            :key="index"
            :index="index"
            :node="item"
            :class="{ active: item == active }"
            :coords="coords"
            @mousedown.native.stop="active = item"
            @click.native.stop="active = item"
            @dblclick.native="openWindow('appFileSystem')"
            @drag-active="active = $event">
        </icon> -->

        <!-- SELECTION.JS -->
        <Selection
            class="kleptos-selection"
            :settings="settings"
            @selected-items="selectedItems = $event"
        >
            <!-- SLOT SCOPE -->
            <template slot-scope="{ selectedStore, touchedElements, inactiveElements }" >
                <!-- :class="getClasses(item, selectedStore, touchedElements, inactiveElements)" -->

                <!-- ICON -->
                <Icon
                    v-for="(item, index) in directory"
                    :class="getClasses(item, selectedStore, touchedElements, inactiveElements)"
                    :index="index"
                    :key="index"
                    :node="item"
                    :style="{ 'top': 90 * index + 'px' }"
                />
            </template>

        </Selection>

        <!-- JUST FOR TESTING -->
        <div class="tracker">
            <pre v-text="tracker()"></pre>
        </div>

    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Icon from './FileSystemIconViewIcon';
    import IconGrid from './FileSystemIconViewGrid';
    import Selection from './VueSelection/Selection-0.1.3';

    // import options for selection.js based on the below pen:
    // https://codepen.io/liquidvisual/pen/NzqzxN
    // import options from './VueSelection/options';
    // import Selection from './selection-js/selection';

    export default {
        components: {
            IconGrid: IconGrid,
            Icon: Icon,
            Selection: Selection
        },
        props: {
            directory: {
                type: [Array, Object], // change back to array?
                required: true
            },

            // if TRUE the grid will generate based on number of files
            // ELSE grid will generate based on area available
            constrain: {
                type: Boolean,
                default: true,
                required: false,
            }
        },
        data(){
            return {
                // active: '',
                // coords: null, // array of coords
                settings: [], //options,
                selectedItems: []
            }
        },
        // computed: {
        //     totalIcons() { // only works if constrained is turned on
        //         return this.constrain ? this.directory.length : false; // constrain or not?
        //     }
        // },
        created() {
            // console.log(typeof(options));
        },
        // mounted() {
            // this.selection_js = Selection.create(options); // init selection.js
            // this.selectedStore = this.selection_js._selectedStore; // reach into Selection object and store the property in Vue - how to make reactive?
        // },

        methods: {
            ...mapActions('gameOS', [
                // 'deselectIcons',
                'openWindow'
            ]),
            tracker() { // for testing
                var arr = [];

                for (var i=0; i < this.selectedItems.length; i++) {
                    arr.push(this.selectedItems[i].__vue__.node.path);
                }
                return arr;
            },
            getClasses (item, selectedItems, touchedElements, inactiveElements) {
                // Combine arrays of selected + touched (touched is when highlighted but not mouseup selected yet)
                const selectedTouched = selectedItems.concat(touchedElements);
                // does this item from the loop match the one from selected/touched?
                // const selected = !!(selectedTouched.find((x) => { return (x.__vue__.node === item) }));
                const selected = !!(selectedTouched.find((x) => { return (x.__vue__.node === item) }));
                /*
                console.log('---------------------------');
                console.log(item);
                console.log('compare:');
                // console.log(item.__vue__.node);
                // console.log(selectedTouched[0]);
                // console.log(item);

                try {
                    console.log('match:');
                    // console.log(selectedTouched[0].__vue__.node === item);
                    // console.log(selectedTouched[0].__vue__.node) // the touched element that is added, isn't actually the same - it's the dragger or something
                    console.log(selectedTouched[0].__vue__.node.path); // <--- works!!
                }
                catch(err) { // do nudda
                }
                console.log('---------------------------');
                */
                // inactive is just a visual class, to show when els are clicked away from
                const inactive = false; //!!(inactiveElements.find((x) => { return (x.__vue__.node === item) }));
                // return class 'selected'
                return { selected: selected, inactive: inactive }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .tracker {
                position: fixed;
                top: 50px;
                right: 20px;
                background: orange;
                padding: 10px;
            }

    .kleptos-icon-view,
    .kleptos-selection {
        position: absolute; // [LOCKED] fills any window
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1; // [LOCKED] - makes drop work
    }
</style>